import { css, cx } from '@eti/styles';
import { Inline } from '@etg/wings';
import type { ReactNode } from 'react';

const inlineStyles = (
  borderColorBefore: string,
  borderColorAfter: string,
  borderSize: number,
  borderStyleBefore: string,
  borderStyleAfter: string,
  childSize: number,
  wrapperSize?: number,
) => css`
  ${borderStyleBefore &&
  `&::before {
      border-left: ${borderSize}px ${borderStyleBefore} ${borderColorBefore};
      top: 0;
      content: '';
      height: 21px;
      position: absolute;
      z-index: 1;
    }`}
  ${borderStyleAfter &&
  `&::after {
      border-left: ${borderSize}px ${borderStyleAfter} ${borderColorAfter};
      bottom: 0;
      content: '';
      height: calc(100% - ${childSize}px - 20px);
      position: absolute;
      z-index: 1;
    }`}

  padding: 20px 0;
  position: relative;
  width: ${wrapperSize ? `${wrapperSize}px` : 'auto'};
`;

interface TimelineWrapperProps {
  borderColorAfter?: string;
  borderColorBefore?: string;
  borderSize?: number;
  borderStyleAfter?: string;
  borderStyleBefore?: string;
  className?: string;
  children?: ReactNode;
  childSize?: number;
  'data-testid'?: string;
  wrapperSize?: number;
}

const TimelineWrapper = ({
  borderColorAfter = '#000',
  borderColorBefore = '#000',
  borderSize = 1,
  borderStyleAfter = '',
  borderStyleBefore = '',
  className,
  children,
  childSize = 20,
  'data-testid': dataTestId,
  wrapperSize,
}: TimelineWrapperProps) => (
  <Inline
    align="center"
    className={cx(
      className,
      inlineStyles(
        borderColorBefore,
        borderColorAfter,
        borderSize,
        borderStyleBefore,
        borderStyleAfter,
        childSize,
        wrapperSize,
      ),
    )}
    data-testid={dataTestId}
  >
    {children}
  </Inline>
);

export default TimelineWrapper;
